import React from 'react'

import { DropdownButton } from 'steps/tips-and-tricks/components/DropdownButton'

const OptionalDropdownButton = ({
  id = `0`,
  label = '',
  links,
  buttonClassName,
  onLinkClick = function (id, text, url) {},
}) => {
  if (Array.isArray(links)) {
    if (links.length === 1) {
      const { id, label, url } = links[0]
      return (
        <div className={`multi-button multi-button-single`}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={buttonClassName}
            tabIndex={0}
            onKeyUp={e => {
              if (e.key === 'Enter') onLinkClick(id, label, url)
            }}
            onClick={() => {
              onLinkClick(id, label, url)
            }}
          >
            {label}
          </a>
        </div>
      )
    } else if (links.length > 1) {
      const reShapedLinks = links.map(item => {
        return {
          id: item.id,
          label: item.label,
          link: item.url,
        }
      })

      return (
        <div>
          <DropdownButton
            text={label}
            items={reShapedLinks}
            onClick={onLinkClick}
            className={buttonClassName}
          />
        </div>
      )
    }
  }

  return <></>
}

export default OptionalDropdownButton
